import {DeleteRecordsConfirmationButton} from '@flexinet/ui-components';

import {useParams} from 'react-router-dom';

import {useDeleteCardsMutation} from '../hooks/useCardsQuery';

interface DeleteRecordButtonProps {
    selectedIds: string[];
    onDeleteComplete?: () => void;
}

/**
 * FNP-918: batch delete, through the shared confirmation button (§2).
 *
 * Now takes the mutation directly instead of instantiating the whole `useCards`
 * list hook. The old version called `useCards(customerId)` purely to reach
 * `deleteRecords`, which mounted a SECOND copy of the list query inside the
 * page header — a duplicate fetch on every render of a button.
 *
 * It also threw when `customerId` was absent. A header button that throws takes
 * the whole page down; it is now simply disabled, which is what "no customer in
 * scope" should look like.
 */
export const DeleteRecordButton = ({
                                       selectedIds,
                                       onDeleteComplete,
                                   }: DeleteRecordButtonProps) => {

    const {id: customerId} = useParams();

    const deleteMutation = useDeleteCardsMutation(customerId ?? '');

    const disabled = selectedIds.length === 0
        || !customerId
        || deleteMutation.isPending;

    return (
        <DeleteRecordsConfirmationButton
            disabled={disabled}
            recordIdsLength={selectedIds.length}
            handleConfirm={() => {
                deleteMutation.mutate(selectedIds);
                onDeleteComplete?.();
            }}
        />
    );
};
